"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = __importDefault(require("../actions/request"));
const utils_1 = require("../utils");
const poll = (utils) => ({ payload, meta }) => __awaiter(void 0, void 0, void 0, function* () {
    const { next } = utils;
    const { maxTries, status, pollInterval = 1000 } = meta;
    let running = true;
    let triesRemaining = maxTries !== null && maxTries !== void 0 ? maxTries : false;
    const runRequest = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!running) {
            return undefined;
        }
        const response = yield request_1.default(utils)(payload);
        const responseStatus = status(response);
        if (responseStatus === 'success') {
            next({
                type: `POLL_SUCCESS_${payload.meta.name}`,
                payload: response,
            });
            return response;
        }
        if (responseStatus === 'failed') {
            next({
                type: `POLL_FAILED_${payload.meta.name}`,
                payload: response,
            });
            throw new Error('Poll failed');
        }
        if (triesRemaining !== false && --triesRemaining < 0) {
            next({
                type: `POLL_FAILED_${payload.meta.name}`,
                meta: {
                    reason: 'MAX_TRIES',
                },
            });
            throw new Error('Max tries reached');
        }
        if (pollInterval > 0) {
            yield utils_1.sleep(pollInterval);
        }
        return runRequest();
    });
    return {
        promise: runRequest(),
        cancel: () => { running = false; },
    };
});
exports.default = poll;
